import SelectWords from "./SelectWords";
export default SelectWords